import { render } from "./EditAnnouncement.vue?vue&type=template&id=1300431f&scoped=true"
import script from "./EditAnnouncement.vue?vue&type=script&lang=js"
export * from "./EditAnnouncement.vue?vue&type=script&lang=js"

import "./EditAnnouncement.vue?vue&type=style&index=0&id=1300431f&scoped=true&lang=css"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1300431f"]])

export default __exports__